var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row gutter-sm q-mb-lg" },
    [
      !_vm.loading
        ? _c(
            "div",
            { staticClass: "col-xs-12 col-sm-4" },
            [
              _c("points", {
                attrs: {
                  score: _vm.score,
                  score_statement: _vm.user_score_statement,
                  home: true
                },
                on: { showStatement: _vm.showStatement }
              })
            ],
            1
          )
        : _vm._e(),
      !_vm.loading
        ? _c(
            "div",
            { staticClass: "col-xs-12 col-sm-4" },
            [
              _c("statistics", {
                attrs: {
                  statistics: _vm.statistics,
                  clientModules: _vm.clientModules
                }
              })
            ],
            1
          )
        : _vm._e(),
      !_vm.loading && _vm.showRanking
        ? _c(
            "div",
            { staticClass: "col-xs-12 col-sm-4" },
            [
              _c("ranking", {
                attrs: { ranking_code: _vm.ranking_code },
                on: {
                  seeAll: function($event) {
                    return _vm.seeAll()
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      !_vm.loading && _vm.showBadges
        ? _c(
            "div",
            { staticClass: "col-12" },
            [_c("badges", { attrs: { badges: _vm.badges } })],
            1
          )
        : _vm._e(),
      _c(
        "q-inner-loading",
        { attrs: { visible: _vm.loading } },
        [_c("q-spinner-dots", { attrs: { size: 60, color: "secondary" } })],
        1
      ),
      _vm.show_all_ranking
        ? _c(
            "q-modal",
            {
              attrs: {
                "content-css": { minWidth: "100vw", minHeight: "100vh" }
              },
              model: {
                value: _vm.show_all_ranking,
                callback: function($$v) {
                  _vm.show_all_ranking = $$v
                },
                expression: "show_all_ranking"
              }
            },
            [
              _c(
                "q-modal-layout",
                [
                  _c(
                    "q-toolbar",
                    { attrs: { slot: "header" }, slot: "header" },
                    [
                      _c("q-btn", {
                        attrs: {
                          flat: "",
                          round: "",
                          dense: "",
                          icon: "fas fa-times"
                        },
                        on: {
                          click: function($event) {
                            _vm.show_all_ranking = false
                          }
                        }
                      }),
                      _c("q-toolbar-title", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("ranking")) +
                            "\n                "
                        )
                      ])
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "layout-padding" },
                    [
                      _c("all-ranking", {
                        attrs: {
                          user_firebase_document_ranking_areas:
                            _vm.user_firebase_document_ranking_areas,
                          user_firebase_document: _vm.ranking_code
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          model: {
            value: _vm.show_statement,
            callback: function($$v) {
              _vm.show_statement = $$v
            },
            expression: "show_statement"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_statement = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("points_statement")) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c("points-statemenet", {
                    attrs: { score_statement: _vm.user_score_statement }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }